import "./scripts/sidebar";

import "./styles/sidebar.scss";
